import {
  InvoiceKindSelect,
  Props as InvoiceKindSelectProps,
} from '@/components/InvoiceKindSelect';
import { memo } from 'react';
import { Control } from 'react-hook-form';
import type { PaymentRequestForm } from '../../../../type';

export type Props = {
  name: string;
  control: Control<PaymentRequestForm, unknown>;
  inputId: string;
  key: string | undefined;
} & InvoiceKindSelectProps<PaymentRequestForm>;

export const InnerInvoiceKind = ({
  control,
  name,
  inputId,
  key,
  selectProps,
  isNotTarget,
}: Props) => {
  return (
    <InvoiceKindSelect<PaymentRequestForm>
      key={key}
      control={control}
      inputId={inputId}
      name={name}
      isNotTarget={isNotTarget}
      selectProps={selectProps}
    />
  );
};

InnerInvoiceKind.displayName = 'InnerInvoiceKind';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const InvoiceKind = memo((props) => (
  <InnerInvoiceKind {...props} />
)) as typeof InnerInvoiceKind;
InvoiceKind.displayName = 'InvoiceKind';
